import React, {useState, useEffect} from 'react'
import {useSelector} from 'react-redux'
import {
  selectKP11SelectCartCentersNApps,
  selectDisabledItems,
  //selectCollapseAllTrigger,
} from '../../../../../../../app-store/kp11CartSlice'
import {
  CardPlanBodyStyle,
  // CardPlanAddToCartStyle,
} from '../../kp-11Link-catalog-cards-style'
// import {kpSuccessIcon} from '../../../../../../../assets'
import {PlanRadioInput} from '../../../../kp-11Link-reusable-components/kp-plan-radio-input'
import {CardPlanItemWrapStyle} from '../../../../kp-11Link-reusable-components/kp-plan-radio-input-style'
import {CardPlanEntitlementsStyle} from '../../../../kp-11Link-reusable-components/kp-plan-ent-checkbox-style'
import {EntCheckboxInput} from '../../../../kp-11Link-reusable-components/kp-plan-ent-checkbox'
// import {DELAY_HIDE_IN_SEC} from '../../../../../../../utils/constants'
import {
  buildCartEntity,
  countryCurrencyEnum,
  isItemAtMaxQty,
} from '../../../../kp-11Link-utility/kp11-utility'
import {GENERIC_CARD_LIST} from '../../../../../../../utils/constants'
import {RegularCardComponent} from '../../../../../kp-card-type/regular-card'
import {KP11LinkSeoCardComponent} from '../kp-11Link-seo-card'
import {KP11LinkThryvLeadsCardComponent} from '../kp-11Link-thryvLeads-card'
import {KP11LinkSocialAdsCardComponent} from '../kp-11link-socialAds-card'
import {KP11WebsiteDesignCard} from './kp-11-website-design-card'
import {KP11AdditionalPageCard} from './kp-11-additional-page-card'
import {useUserFeatures} from '../../../../../../../context/user-features-context'

const getProductPrice = (prices, country = 'US') => {
  const currency = countryCurrencyEnum[country] || ''
  const price = prices?.find(p => p.currency === currency)
  return price ? price.unitAmount : null
}

export const KP11ThryvAddonsCardComponent = ({
  selectedCountry,
  groupKey,
  items,
  onSelectItem,
  disabled,
  addedToCart,
  onSEOAddonChange,
  groupCustomFields,
  onGroupCustomFieldsUpdate,
  expanded,
  setExpanded,
}) => {
  // Get selectedItem from Redux instead of props
  const {TL_Tax_Plan_Enabled} = useUserFeatures()
  const disabledItems = useSelector(selectDisabledItems)
  const reduxCartCentersAndApps = useSelector(selectKP11SelectCartCentersNApps)
  const centers = reduxCartCentersAndApps?.centers?.map(item => item.code) || []
  const apps = reduxCartCentersAndApps?.apps?.map(item => item.code) || []
  const oneTimeFee =
    reduxCartCentersAndApps?.oneTimeFees?.map(item => item.code) || []
  const codeList = [...centers, ...apps, ...oneTimeFee]

  // Find selected item from cart by checking if any item code matches the current group's items
  const allCartItems = [
    ...(reduxCartCentersAndApps?.centers || []),
    ...(reduxCartCentersAndApps?.apps || []),
    ...(reduxCartCentersAndApps?.oneTimeFees || []),
  ]
  const selectedItemInCart = allCartItems.find(cartItem =>
    items.some(item => item.code === cartItem.code),
  )
  //const [isExpanded, setIsExpanded] = useState(false)
  //const collapseAllTrigger = useSelector(selectCollapseAllTrigger)
  const availableAddons =
    (selectedItemInCart &&
      items.find(i => i.id === selectedItemInCart.id)?.entitlements) ||
    []

  // const [add2CartBannerStatus, setAdd2BannerStatus] = useState(addedToCart)
  const [itemList, setItemList] = useState([])
  // useEffect(() => {
  //   if (addedToCart) {
  //     setAdd2BannerStatus(true)
  //     setTimeout(() => {
  //       setAdd2BannerStatus(false)
  //     }, DELAY_HIDE_IN_SEC * 1000)
  //   }
  // }, [addedToCart])
  // useEffect(() => {
  //   setExpanded(false)
  // }, [collapseAllTrigger, setExpanded])

  useEffect(() => {
    let independentList = []
    let socialList = []
    items.map(item => {
      if (item.code.includes('socialads')) {
        socialList.push(item)
      } else {
        independentList.push(item)
      }
      return item
    })
    if (socialList.length > 0) {
      setItemList([
        ...independentList,
        {
          key: 'socialAds',
          code: 'socialads',
          items: socialList,
          ...socialList[0],
        },
      ])
    } else {
      setItemList(independentList)
    }
  }, [])

  // const checkAddonDisableStatus = item => {
  //   let requiredItemsCodeList = []
  //   if (item?.items && item?.items.length > 0) {
  //     requiredItemsCodeList = [
  //       ...(item?.items[0].requires || []),
  //       ...(item?.items[0].requiresCenter || []),
  //       ...(item?.items[0].requiresAddon || []),
  //     ]
  //   } else {
  //     requiredItemsCodeList = [
  //       ...(item?.requires || []),
  //       ...(item?.requiresCenter || []),
  //       ...(item?.requiresAddon || []),
  //     ]
  //   }
  //   if (requiredItemsCodeList.length === 0) {
  //     return false
  //   }
  //   const isAddonDisabled = !requiredItemsCodeList.some(requiredCode =>
  //     codeList.includes(requiredCode),
  //   )
  //   return isAddonDisabled
  // }
  return (
    <>
      <CardPlanBodyStyle>
        <CardPlanItemWrapStyle wrap={true} column={true}>
          {itemList.map(item => {
            const isCodeSelected = codeList.includes(item.code)
            if (GENERIC_CARD_LIST.includes(item.code)) {
              return (
                <RegularCardComponent
                  key={item.id}
                  groupKey={groupKey}
                  isChecked={isCodeSelected}
                  handleCardAction={() => {
                    if (!isCodeSelected) {
                      const updatedItem = buildCartEntity({
                        kind: 'item',
                        source: {
                          ...item,
                          groupKey,
                          section:
                            item.prod_type === 'Center'
                              ? 'centers'
                              : item.prod_type === 'OneTimeFees'
                              ? 'oneTimeFees'
                              : 'apps',
                        },
                      })
                      onSelectItem(updatedItem)
                    }
                  }}
                  isDisabled={disabledItems[item.code] || false}
                  country={selectedCountry}
                  cardDetails={item}
                />
              )
            } else if (item.code.includes('seo')) {
              return (
                <div
                  key={item.code + '-' + groupKey}
                  className="card-plan-item"
                >
                  <KP11LinkSeoCardComponent
                    selectedCountry={selectedCountry}
                    groupKey={groupKey}
                    key={groupKey}
                    items={[item]}
                    onSelectItem={onSelectItem}
                    disabled={disabledItems[item.code] || false}
                    addedToCart={addedToCart}
                    onSEOAddonChange={onSEOAddonChange}
                    groupCustomFields={groupCustomFields}
                    onGroupCustomFieldsUpdate={onGroupCustomFieldsUpdate}
                  />
                </div>
              )
            } else if (item.code.startsWith('tl-')) {
              if (item.code.includes('tax') && !TL_Tax_Plan_Enabled) return null
              if (!item.code.includes('tax') && TL_Tax_Plan_Enabled) return null
              return (
                <div
                  key={item.code + '-' + groupKey}
                  className="card-plan-item  w-100"
                  style={{maxWidth: '100%'}}
                >
                  <KP11LinkThryvLeadsCardComponent
                    isChildComponent={true}
                    selectedCountry={selectedCountry}
                    groupKey={groupKey}
                    key={groupKey}
                    items={[item]}
                    onSelectItem={onSelectItem}
                    disabled={disabledItems[item.code] || false}
                    addedToCart={addedToCart}
                    onSEOAddonChange={onSEOAddonChange}
                    groupCustomFields={groupCustomFields}
                    onGroupCustomFieldsUpdate={onGroupCustomFieldsUpdate}
                  />
                </div>
              )
            } else if (item.code.includes('addon-5-website_difm')) {
              return (
                <div
                  key={item.code + '-' + groupKey}
                  className="card-plan-item  w-100"
                  style={{maxWidth: '100%'}}
                >
                  <KP11WebsiteDesignCard
                    isChildComponent={true}
                    selectedCountry={selectedCountry}
                    isChecked={isCodeSelected}
                    groupKey={groupKey}
                    key={groupKey}
                    item={item}
                    onSelectItem={onSelectItem}
                    disabled={disabledItems[item.code] || false}
                    addedToCart={addedToCart}
                    onSEOAddonChange={onSEOAddonChange}
                    groupCustomFields={groupCustomFields}
                    onGroupCustomFieldsUpdate={onGroupCustomFieldsUpdate}
                  />
                </div>
              )
            } else if (item.code.includes('thryv5page')) {
              const additionalPagesCartItem = [
                ...(reduxCartCentersAndApps?.centers || []),
                ...(reduxCartCentersAndApps?.apps || []),
                ...(reduxCartCentersAndApps?.oneTimeFees || []),
              ].find(cartItem => cartItem?.code === item.code)

              return (
                <KP11AdditionalPageCard
                  key={item.id}
                  isChecked={codeList.includes(item.code)}
                  disabled={
                    disabledItems[item.code] ||
                    isItemAtMaxQty({
                      cartCentersAndApps: reduxCartCentersAndApps,
                      item,
                    })
                  }
                  name={item.name}
                  price={getProductPrice(item?.currencies, selectedCountry)}
                  groupKey={groupKey}
                  itemCode={item.code}
                  onSave={finalValue => {
                    const updatedItem = buildCartEntity({
                      source: {
                        ...item,
                        groupKey,
                      },
                      quantity: finalValue,
                    })
                    onSelectItem(updatedItem)
                    onGroupCustomFieldsUpdate({
                      keapAdditionalPagesValue: finalValue,
                    })
                  }}
                  quantity={
                    additionalPagesCartItem?.quantity ??
                    groupCustomFields?.keapAdditionalPagesValue
                  }
                />
              )
            } else if (item.code.includes('socialads')) {
              return (
                <KP11LinkSocialAdsCardComponent
                  isChildComponent={true}
                  selectedCountry={selectedCountry}
                  groupKey={groupKey}
                  key={groupKey}
                  items={item.items}
                  onSelectItem={onSelectItem}
                  disabled={disabledItems[item.code] || false}
                  addedToCart={addedToCart}
                  onSEOAddonChange={onSEOAddonChange}
                  groupCustomFields={groupCustomFields}
                  onGroupCustomFieldsUpdate={onGroupCustomFieldsUpdate}
                  disabledItems={disabledItems}
                />
              )
            } else {
              return (
                <>
                  <PlanRadioInput
                    key={item.id}
                    checked={codeList.includes(item.code)}
                    onChange={() => {
                      const updatedItem = buildCartEntity({
                        kind: 'item',
                        source: {
                          ...item,
                          groupKey,
                          section: items[0]?.section,
                        },
                      })
                      onSelectItem(updatedItem)
                    }}
                    item={item}
                    disabled={disabledItems[item.code] || false}
                    country={selectedCountry}
                  />
                </>
              )
            }
          })}
        </CardPlanItemWrapStyle>

        {/* Addons (entitlements) in checkbox */}
        {availableAddons.length > 0 && (
          <CardPlanEntitlementsStyle>
            {availableAddons.map(ent => (
              <EntCheckboxInput
                key={ent.id}
                checked={
                  selectedItemInCart?.addons?.some(a => a.code === ent.code) ||
                  false
                }
                label={ent.name}
                disabled={disabled}
              />
            ))}
          </CardPlanEntitlementsStyle>
        )}
        {/* {add2CartBannerStatus && (
          <CardPlanAddToCartStyle>
            <img src={kpSuccessIcon} alt="success icon" />
            <span>Added to cart</span>
          </CardPlanAddToCartStyle>
        )} */}
      </CardPlanBodyStyle>
    </>
  )
}
